// ** Reducers Imports
import navbar from './navbar';
import layout from './layout';
import tabs from './tabs';
import auth from './authentication';
import permission from './permission';
import users from '../views/Setup/User/store';
import roles from '../views/Setup/RoleRights/Role/store';
import moduleSlice from '../views/Setup/ModuleManage/store';
import appUsers from '../views/AppUser/store';
import vehicleType from '../views/Master/VehicleType/store';
import vehicleBrand from '../views/Master/VehicleBrand/store';
import vehicleModel from '../views/Master/VehicleModel/store';
import vehicle from '../views/Master/Vehicle/store';
import kycDoc from '../views/Master/KycDoc/store';
import vehicleKycDoc from '../views/Master/VehicleKycDoc/store';
import challanType from '../views/Master/ChallanType/store';
import challanRule from '../views/Master/ChallanRule/store';
import speedConfiguration from '../views/Master/SpeedConfiguration/store';
import autoInsurance from '../views/AutoInsurance/store';
import sos from '../views/Master/Sos/store';
import insuranceOffer from '../views/Master/InsuranceOffer/store';
import vehicleSpecification from '../views/Master/VehicleSpecification/store';
import emergencyContact from '../views/EmergencyContact/store';
import faqCategorySlice from '../views/Master/FaqCategory/store';
import faq from '../views/Master/Faq/store';
import helpDeskActiveClosedSlice from '../views/Help/HelpDesk/store';
import purpose from '../views/Master/Purpose/store';
import vehicleCategory from '../views/Master/Category/store';
import history from '../views/History/store';
import mapSetting from '../views/MapSetting/store';
import dashboardSlice from '../views/Dashboard/store';
import roadType from '../views/Master/RoadType/store';
import roadSpeedRule from '../views/Master/RoadSpeedRule/store';
import deviceCategory from '../views/Master/DeviceCategory/store';
import device from '../views/Master/Device/store';
import road from '../views/Master/Road/store';
import email from '../views/Notifications/store';
import driver from '../views/ActiveUsers/Drivers/store';
import doctor from '../views/ActiveUsers/Doctor/store';
import fencing from '../views/Fencing/store/index';
import rto from '../views/Master/Rto/store';
import liveTrackingSlice from '../views/LiveTracking/store';
import patchPolicy from '../views/Master/PatchPolicy/store';
import emphoraDeviceSlice from '../views/Master/EmphoraDevice/store';
import violationSlice from '../views/Report/Violation/store';
import department from '../views/Master/Department/store';
import employmentStatus from '../views/Master/EmploymentStatus/store';
import sector from '../views/Master/Sector/store';
import AuditLogs from '../views/Audit/AuditLogs/store';
import Satellite from '../views/SatelliteView/store';
import telemetricSlice from '../views/Report/Telemetry/component/store';

const rootReducer = {
    auth,
    navbar,
    tabs,
    layout,
    permission,
    users,
    appUsers,
    roles,
    moduleSlice,
    vehicleType,
    vehicleBrand,
    vehicleModel,
    vehicle,
    kycDoc,
    vehicleKycDoc,
    challanType,
    challanRule,
    speedConfiguration,
    autoInsurance,
    sos,
    insuranceOffer,
    vehicleSpecification,
    emergencyContact,
    faqCategorySlice,
    faq,
    helpDeskActiveClosedSlice,
    purpose,
    vehicleCategory,
    email,
    history,
    mapSetting,
    dashboardSlice,
    roadType,
    roadSpeedRule,
    deviceCategory,
    device,
    driver,
    doctor,
    fencing,
    rto,
    road,
    liveTrackingSlice,
    patchPolicy,
    emphoraDeviceSlice,
    violationSlice,
    employmentStatus,
    sector,
    department,
    AuditLogs,
    Satellite,
    telemetricSlice
};

export default rootReducer;
